if (!customElements.get('akwatix-signature-cross-sell')) {
  customElements.define('akwatix-signature-cross-sell', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const select = form.querySelector('select');
      const button = form.querySelector('button');
      const error = this.querySelector('[role="alert"]');
      select.addEventListener('change', (event) => {
        event.stopPropagation();
        const option = select.selectedOptions[0];
        const image = this.querySelector('[data-cap-image]');
        image.src = option.dataset.image;
        image.alt = option.dataset.alt;
        this.querySelector('[data-cap-price]').textContent = option.dataset.price;
      });
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (this.busy) return;
        this.busy = true;
        button.disabled = true;
        error.hidden = true;
        const id = select.value;
        const cart = document.querySelector('cart-drawer');
        const body = new FormData(form);
        if (this.dataset.placement === 'drawer' && cart?.getSectionsToRender) {
          body.append('sections', cart.getSectionsToRender().map(section => section.id).join(','));
          body.append('sections_url', location.pathname);
        }
        let added = false;
        try {
          const response = await fetch(form.action + '.js', { method: 'POST', body, headers: {'Accept':'application/json','X-Requested-With':'XMLHttpRequest'} });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || this.dataset.error);
          added = true;
          if (this.dataset.placement === 'drawer' && cart?.renderContents && data.sections) {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {source:'akwatix-signature', productVariantId:id, cartData:data});
            }
            cart.renderContents(data);
            cart.classList.remove('is-empty');
            requestAnimationFrame(() => {
              const checkout = cart.querySelector('[name="checkout"]');
              cart.setActiveElement?.(document.querySelector('#cart-icon-bubble'));
              if (typeof trapFocus === 'function') trapFocus(cart.querySelector('#CartDrawer'), checkout);
              checkout?.focus({preventScroll:true});
            });
          } else {
            location.assign(form.querySelector('[name="return_to"]').value);
          }
        } catch (failure) {
          if (added) {
            location.assign(form.querySelector('[name="return_to"]').value);
            return;
          }
          error.textContent = failure.message || this.dataset.error;
          error.hidden = false;
          this.busy = false;
          button.disabled = false;
        }
      });
    }
  });
}
